// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
import { selectValue } from "#/admin/legacy/sp-select/index.js";
import { loadSelectItems } from "#/admin/legacy/sp-select/load-select-items.js";

const CATEGORIES_URL = "/admin/categories.json?api=quantum";

/**
 * Loads the categories into `categorySelect` and lists those of the entity `entitySelect` shows when they arrive;
 * returns the payload, or null when loading fails.
 */
export async function loadEntityCategories(entitySelect, categorySelect, categoryId) {
  const payload = await loadSelectItems(categorySelect, CATEGORIES_URL, {
    selected: categoryId,
    includeBlank: true,
  });

  if (!payload) {
    return null;
  }

  showEntityCategories(entitySelect, categorySelect, payload.items, entitySelect.value);

  return payload;
}

/**
 * Selects `entityType` and lists the placeholder, the categories without an entity type and that entity's categories,
 * keeping a still-listed category.
 */
export function showEntityCategories(entitySelect, categorySelect, categories, entityType) {
  const selected = categorySelect.value;
  const selectedEntity = selectValue(entitySelect.items, entityType);

  function listedFor(item) {
    const itemEntity = item.dataset?.entityType;

    return item.placeholder || !itemEntity || itemEntity === selectedEntity;
  }

  const choices = categories.filter(listedFor);

  entitySelect.value = selectedEntity;
  categorySelect.items = choices;
  categorySelect.value = selectValue(categorySelect.items, selected);
}
